function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1118,
    height: 1054,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 357,
    r: 357,
    fill: "#6bb97f",
    fillOpacity: 0.25,
    opacity: 0.5,
    style: {
      fill: "#2951c3",
      fillOpacity: 0.25098041
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 558.539,
    cy: 533.047,
    fill: "#6BB97F",
    fillOpacity: 0.25,
    opacity: 0.5,
    rx: 445,
    ry: 357,
    style: {
      fill: "#2951c3",
      fillOpacity: 0.25098041
    },
    transform: "rotate(-26.983 558.539 533.047)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground1);
export default __webpack_public_path__ + "static/media/background1.b664d83570c0463759b415bf6f12e926.svg";
export { ForwardRef as ReactComponent };